import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SavedCardDto } from "../../pages/saved-card-list/models/saved-card.models";

@Component({
  selector: "app-card-item",
  templateUrl: "./card-item.component.html",
  styleUrls: ["./card-item.component.scss"],
})
export class CardItemComponent {
  @Input() item: SavedCardDto | undefined;
  @Input() isEditable: boolean = true;

  @Output() deleteCardEvent: EventEmitter<SavedCardDto> = new EventEmitter<SavedCardDto>();

  deleteCard(item: SavedCardDto) {
    this.deleteCardEvent.emit(item);
  }
}
